import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { RadioButtonGroup } from 'common-components'
import { editPensionAgeKoomverRetire } from 'quick-quote/product-common/coverage-plan/actions'
import { getActivePensionAgePlanKoomverRetire, getAvaliablePensionAgePlanKoomverRetire } from '../selectors'
import MESSAGES from 'core/data-model/constants/messages'

export const KoomverRetirePensionAgeSelection = ({
  getActivePensionAgePlanKoomverRetire,
  getAvaliablePensionAgePlanKoomverRetire,
  selectPensionAge,
}) => {
  const pensionAgeOptionPlan = [
    {
      text: '55 ปี',
      value: 55,
      canSelectable: getAvaliablePensionAgePlanKoomverRetire.includes(55),
    },
    {
      text: '60 ปี',
      value: 60,
      canSelectable: getAvaliablePensionAgePlanKoomverRetire.includes(60),
    },
    {
      text: '65 ปี',
      value: 65,
      canSelectable: getAvaliablePensionAgePlanKoomverRetire.includes(65),
    },
  ]

  return (
    <div className="form-group">
      <div className="form-group-title">
        <span className="form-group-title-text">เลือกอายุรับบำนาญ</span>
      </div>
      <RadioButtonGroup
        keyToGetValue="value"
        className="model-factor"
        onChange={selectPensionAge}
        value={getActivePensionAgePlanKoomverRetire}
        options={pensionAgeOptionPlan}
      />
      {Array.isArray(getAvaliablePensionAgePlanKoomverRetire) && getAvaliablePensionAgePlanKoomverRetire.length < 3 && (
        <div className="info-message attached-icon form-control-feedback" style={{ marginTop: '0px' }}>
          <p>{MESSAGES.PENSION_AGE_SELECTION_INFO_MESSAGE}</p>
        </div>
      )}
    </div>
  )
}

const mapStateToProps = (state) => ({
  getActivePensionAgePlanKoomverRetire: getActivePensionAgePlanKoomverRetire(state),
  getAvaliablePensionAgePlanKoomverRetire: getAvaliablePensionAgePlanKoomverRetire(state),
})

const mapDispatchToProps = (dispatch) => ({
  selectPensionAge: bindActionCreators(editPensionAgeKoomverRetire, dispatch),
})

export default connect(mapStateToProps, mapDispatchToProps)(KoomverRetirePensionAgeSelection)
